import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Scroll from "./Components/Scroll";
import SingleProduct from "./Components/SingleProduct";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import Services from "./Pages/Services";
import Privacy from "./Pages/Privacy";
import Certificates from "./Pages/certificates";
import { Gallery } from "./Pages/Gallery";
import MappingServices from "./Components/service/serviceone";
import CalibrationInstrument from "./Components/service/calibrationInstruments";
import HvacSerivce from "./Components/service/hvacService.js";
import OtherService from "./Components/service/otherService.js";
import Client from "./Components/client.js";

const App = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service1" element={<MappingServices />} />
        <Route path="/hvacservice" element={<HvacSerivce />} />
        <Route path="/otherservice" element={<OtherService />} />
        <Route path="/client" element={<Client />} />
        <Route path="/calibrationInstruments" element={<CalibrationInstrument />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/about" element={<About />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/product/:id" element={<SingleProduct />} />
      </Routes>
      <Footer />
      <Scroll />
    </>
  );
};

export default App;
